
// ════════════════════════════════════════════════════════
//  USERBOT PAGE - Telethon shaxsiy akkaunt ulash
import { useState, useEffect, useCallback } from 'react'
import { Card, ConfirmDeleteModal } from '../components/UI'
import { Modal, Badge, Dot } from '../ui'
import { Spinner, EmptyState } from '../hooks/useApi.jsx'
import { useStore } from '../store'
import {
  HiCheck, HiPlay, HiStop, HiArrowPath, HiTrash, HiUser,
} from 'react-icons/hi2'

import api from '../api'

// Auth steps
const STEP = { FORM: 'form', CODE: 'code', TFA: 'tfa', DONE: 'done' }

function AddAccountModal({ open, onClose, onSuccess }) {
  const [step, setStep] = useState(STEP.FORM)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [accountId, setAccountId] = useState('')
  const { addToast } = useStore()

  const [phone, setPhone]     = useState('')
  const [apiId, setApiId]     = useState('')
  const [apiHash, setApiHash] = useState('')
  const [code, setCode]       = useState('')
  const [tfa, setTfa]         = useState('')

  const reset = () => {
    setStep(STEP.FORM); setError('')
    setPhone(''); setApiId(''); setApiHash('')
    setCode(''); setTfa(''); setAccountId('')
  }

  const handleClose = () => { reset(); onClose() }

  // 1-qadam: Telefon + API ma'lumotlar
  const handleSendCode = async () => {
    if (!phone || !apiId || !apiHash) return setError("Barcha maydonlar to'ldirilishi shart")
    setLoading(true); setError('')
    try {
      const res = await api.post('/userbot/accounts', {
        phone: phone.startsWith('+') ? phone : '+' + phone,
        api_id: parseInt(apiId),
        api_hash: apiHash,
      })
      if (res.status === 'code_sent') {
        setAccountId(res.id)
        setStep(STEP.CODE)
      } else {
        setError(res.detail || JSON.stringify(res))
      }
    } catch (e) { setError(e.message) }
    finally { setLoading(false) }
  }

  // 2-qadam: OTP kodni tasdiqlash
  const handleVerifyCode = async () => {
    if (!code) return setError("OTP kod kiritilishi shart")
    setLoading(true); setError('')
    try {
      const res = await api.post(`/userbot/accounts/${accountId}/verify`, { code, password: '' })
      if (res.status === 'ok') {
        setStep(STEP.DONE)
        setTimeout(() => { handleClose(); onSuccess() }, 1500)
      } else if (res.status === 'need_2fa') {
        setStep(STEP.TFA)
      } else {
        setError(res.detail || 'Tasdiqlashda xato')
      }
    } catch (e) { setError(e.message) }
    finally { setLoading(false) }
  }

  // 3-qadam: 2FA parol
  const handleVerify2FA = async () => {
    if (!tfa) return setError("2FA parol kiritilishi shart")
    setLoading(true); setError('')
    try {
      const res = await api.post(`/userbot/accounts/${accountId}/verify`, { code, password: tfa })
      if (res.status === 'ok') {
        setStep(STEP.DONE)
        setTimeout(() => { handleClose(); onSuccess() }, 1500)
      } else {
        setError(res.detail || 'Tasdiqlashda xato')
      }
    } catch (e) { setError(e.message) }
    finally { setLoading(false) }
  }

  const handleResend = async () => {
    setLoading(true); setError('')
    try {
      const res = await api.post(`/userbot/accounts/${accountId}/resend_code`, {})
      if (res.status === 'code_sent') {
        setError('')
        addToast('Yangi kod yuborildi', 'ok')
      } else {
        setError(res.detail || 'Xato')
      }
    } catch (e) { setError(e.message) }
    finally { setLoading(false) }
  }

  // Kit Modal: role="dialog", aria-modal, Esc, fokus qopqoni va skroll bloki ichida (DESIGN.md 8)
  return (
    <Modal open={open} onClose={handleClose} title="Telegram akkaunt ulash" size="sm">
      <p style={{ fontSize: 12, color: 'var(--text-3)', margin: '0 0 16px' }}>
        {step === STEP.FORM ? "1/3 — Ma'lumotlar" :
         step === STEP.CODE ? '2/3 — OTP kod' :
         step === STEP.TFA  ? '3/3 — 2FA parol' :
         'Muvaffaqiyatli ulandi!'}
      </p>

      {/* Steps indicator */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {[STEP.FORM, STEP.CODE, step === STEP.TFA ? STEP.TFA : STEP.DONE].map((s, i) => {
          const done   = [STEP.FORM, STEP.CODE, STEP.TFA, STEP.DONE].indexOf(step) > i
          const active = step === s
          return (
            <div key={i} style={{ flex: 1, height: 4, borderRadius: 'var(--r)',
              background: done ? 'var(--text-1)' : active ? 'var(--border-2)' : 'var(--border)',
              transition: 'background var(--dur-1) var(--ease)' }} />
          )
        })}
      </div>

      {error && (
        <div style={{ background: 'var(--ui-st-critical-bg)', border: '1px solid var(--ui-st-critical)',
          borderRadius: 'var(--r)', padding: '10px 12px', marginBottom: 16, fontSize: 13,
          color: 'var(--ui-st-critical)', fontWeight: 500 }}>
          {error}
        </div>
      )}

      {/* STEP 1: Form */}
      {step === STEP.FORM && (
        <div>
          <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 'var(--r)',
            padding: '12px 14px', marginBottom: 16, fontSize: 12, color: 'var(--text-2)', lineHeight: 1.7 }}>
            <strong>API ID va Hash</strong> olish uchun:<br/>
            1. <a href="https://my.telegram.org" target="_blank" rel="noreferrer" style={{ color: 'var(--text-1)' }}>my.telegram.org</a> ga kiring<br/>
            2. <strong>API development tools</strong> — Yangi app yarating<br/>
            3. <strong>api_id</strong> va <strong>api_hash</strong> ni nusxa oling
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label htmlFor="ub-phone" style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-2)', display: 'block', marginBottom: 4 }}>Telefon raqam *</label>
              <input id="ub-phone" className="form-input" value={phone} onChange={e=>setPhone(e.target.value)} placeholder="+998901234567" />
            </div>
            <div>
              <label htmlFor="ub-api-id" style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-2)', display: 'block', marginBottom: 4 }}>API ID *</label>
              <input id="ub-api-id" className="form-input" value={apiId} onChange={e=>setApiId(e.target.value)} placeholder="12345678" type="number" />
            </div>
            <div>
              <label htmlFor="ub-api-hash" style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-2)', display: 'block', marginBottom: 4 }}>API Hash *</label>
              <input id="ub-api-hash" className="form-input" value={apiHash} onChange={e=>setApiHash(e.target.value)} placeholder="0123456789abcdef0123456789abcdef" type="password" />
            </div>
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 16 }}
            onClick={handleSendCode} disabled={loading}>
            {loading ? <Spinner size={16} /> : 'OTP kod yuborish'}
          </button>
        </div>
      )}

      {/* STEP 2: OTP */}
      {step === STEP.CODE && (
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>{phone} ga kod yuborildi</p>
          <p style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 16, lineHeight: 1.6 }}>
            Telegram ilovangizga kelgan <strong>5 xonali kodni</strong> kiriting
          </p>
          <input className="form-input" value={code} onChange={e=>setCode(e.target.value.replace(/\D/g,'').slice(0,5))}
            placeholder="12345" maxLength={5} aria-label="OTP kod"
            style={{ textAlign: 'center', fontSize: 28, fontWeight: 600, letterSpacing: 12, fontFamily: 'var(--mono)', marginBottom: 16 }}
            autoFocus
          />
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
            onClick={handleVerifyCode} disabled={loading || code.length < 5}>
            {loading ? <Spinner size={16} /> : <><HiCheck aria-hidden="true" /> Tasdiqlash</>}
          </button>
          <button style={{ background: 'none', border: 'none', color: 'var(--text-2)', cursor: 'pointer', fontSize: 12, marginTop: 12, fontFamily: 'var(--font)' }}
            onClick={handleResend} disabled={loading}>
            Kodni qayta yuborish
          </button>
        </div>
      )}

      {/* STEP 3: 2FA */}
      {step === STEP.TFA && (
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>2FA parol kerak</p>
          <p style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 16, lineHeight: 1.6 }}>
            Akkauntingizda ikki bosqichli tekshiruv yoqilgan.<br/>
            Telegram parolini kiriting.
          </p>
          <input className="form-input" value={tfa} onChange={e=>setTfa(e.target.value)}
            type="password" placeholder="Telegram parol" aria-label="2FA parol"
            style={{ marginBottom: 16, textAlign: 'center' }} autoFocus
          />
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
            onClick={handleVerify2FA} disabled={loading || !tfa}>
            {loading ? <Spinner size={16} /> : 'Kirish'}
          </button>
        </div>
      )}

      {/* DONE */}
      {step === STEP.DONE && (
        <div style={{ textAlign: 'center', padding: '16px 0' }}>
          <HiCheck size={32} aria-hidden="true" style={{ color: 'var(--ui-st-ok)' }} />
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ui-st-ok)', marginTop: 8 }}>Muvaffaqiyatli ulandi!</div>
          <div style={{ fontSize: 13, color: 'var(--text-3)', marginTop: 8 }}>Xabarlar endi CRT ga tushadi</div>
        </div>
      )}
    </Modal>
  )
}

// Holat — bosqich, shuning uchun rang faqat "ulangan / kutilmoqda" signalida (DESIGN.md 4)
const STATE_TONE  = { authenticated: 'ok', code_sent: 'medium', pending: 'neutral' }
const STATE_LABEL = { authenticated: 'Ulangan', code_sent: 'Kod kutilmoqda', pending: 'Ulanmagan' }

export function UserBots() {
  const [accounts, setAccounts] = useState([])
  const [loading, setLoading]   = useState(true)
  const [modal, setModal]       = useState(false)
  const [deleteAcc, setDeleteAcc] = useState(null)
  const { addToast } = useStore()

  const load = useCallback(async () => {
    setLoading(true)
    try { setAccounts(await api.get('/userbot/accounts')) }
    catch {}
    finally { setLoading(false) }
  }, [])

  useEffect(() => { load() }, [load])

  const handleToggle = async (acc) => {
    try { await api.put(`/userbot/accounts/${acc.id}/toggle`); await load() }
    catch (e) { addToast(e.message || 'Akkaunt holatini o\'zgartirib bo\'lmadi', 'critical') }
  }

  const handleDelete = (acc) => {
    setDeleteAcc(acc)
  }

  const confirmDelete = async () => {
    if (!deleteAcc) return
    try { await api.delete(`/userbot/accounts/${deleteAcc.id}`); await load(); setDeleteAcc(null) }
    catch (e) { addToast(e.message || 'Akkauntni o\'chirib bo\'lmadi', 'critical') }
  }

  return (
    <Card
      title="Telegram Akkauntlar"
      actions={
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn-refresh-icon" onClick={load} title="Yangilash" aria-label="Yangilash">
            <HiArrowPath aria-hidden="true" />
          </button>
          <button className="btn btn-primary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={() => setModal(true)}>+ Akkaunt ulash</button>
        </div>
      }
    >
      <div className="card-body">

      <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 'var(--r-lg)', padding: '14px 16px', marginBottom: 16, fontSize: 13, color: 'var(--text-2)', lineHeight: 1.8 }}>
        <strong>Bu nima?</strong> Shaxsiy Telegram akkauntingizni ulasangiz, sizga yozgan
        <em>har bir odamdan</em> xabar avtomatik CRT ga tushadi va operatorlar javob beradi.
        Bot emas — haqiqiy akkaunt sifatida ishlaydi.
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:40 }}><Spinner size={28} /></div>
      ) : accounts.length === 0 ? (
        <EmptyState
          text="Telegram akkaunti ulanmagan"
          subtext="Tizim orqali fuqarolar bilan shaxsiy muloqotni boshlash uchun birinchi Telegram akkauntingizni ulang."
          action={<button className="btn btn-primary" onClick={() => setModal(true)}>+ Akkaunt ulash</button>}
        />
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:16 }}>
          {accounts.map(acc => (
            <div key={acc.id} className="card">
              <div className="card-hdr">
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:44, height:44, borderRadius:'var(--r-lg)', background:'var(--surface-2)',
                    border:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <HiUser size={20} aria-hidden="true" style={{ color:'var(--text-2)' }} />
                  </div>
                  <div>
                    <div style={{ fontSize:14, fontWeight:600 }}>{acc.display_name || acc.phone}</div>
                    {acc.username && <div style={{ fontSize:11, color:'var(--text-2)', fontWeight:500 }}>@{acc.username}</div>}
                    <div style={{ fontSize:11, color:'var(--text-3)', display:'flex', alignItems:'center', gap:6 }}>
                      <Dot tone={acc.is_connected ? 'ok' : 'off'} label={acc.is_connected ? 'Ulangan' : 'Uzilgan'} />
                      {acc.phone}
                    </div>
                  </div>
                </div>
                <Badge tone={STATE_TONE[acc.auth_state] || 'neutral'}>
                  {STATE_LABEL[acc.auth_state] || acc.auth_state}
                </Badge>
              </div>
              <div className="card-body">
                <div style={{ display:'flex', gap:8 }}>
                  {acc.auth_state === 'authenticated' && (
                    <button className={`btn btn-sm ${acc.is_active ? 'btn-danger' : 'btn-success'}`} style={{ flex:1, justifyContent:'center' }}
                      onClick={() => handleToggle(acc)}>
                      {acc.is_active ? <><HiStop aria-hidden="true" /> To'xtatish</> : <><HiPlay aria-hidden="true" /> Ishga tushirish</>}
                    </button>
                  )}
                  {acc.auth_state === 'code_sent' && (
                    <div style={{ flex:1, fontSize:12, color:'var(--ui-st-medium)', textAlign:'center', padding:'8px 0', fontWeight:500 }}>
                      Kod kiritilishi kutilmoqda
                    </div>
                  )}
                  <button className="btn btn-danger btn-sm btn-icon" title="O'chirish"
                    aria-label={`${acc.display_name || acc.phone} akkauntini o'chirish`}
                    onClick={() => handleDelete(acc)}>
                    <HiTrash aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <AddAccountModal
        open={modal}
        onClose={() => setModal(false)}
        onSuccess={() => { setModal(false); load() }}
      />

      <ConfirmDeleteModal
        open={!!deleteAcc}
        onClose={() => setDeleteAcc(null)}
        onConfirm={confirmDelete}
        itemName={deleteAcc?.display_name || deleteAcc?.phone || ''}
      />
      </div>
    </Card>
  )
}
